import React from 'react';
import PropTypes from 'prop-types';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import { addToQuery } from '../../../helpers';

const iconButtonElement = (
    <IconButton>
        <MoreVertIcon />
    </IconButton>
);

const anchorOrigin = {
    horizontal: 'right',
    vertical: 'top'
};

const targetOrigin = {
    horizontal: 'right',
    vertical: 'top'
};

const onClick = (value, id) => () => {
    if (value !== undefined || id != null) {
        addToQuery(value, id);
    }
};

const IconMenuCell = ({ interestId }) => {
    return (
        <IconMenu iconButtonElement={iconButtonElement} anchorOrigin={anchorOrigin} targetOrigin={targetOrigin}>
            <MenuItem primaryText="Edit" onClick={onClick('addInterestDialog', interestId)} />
            <MenuItem primaryText="Delete" onClick={onClick('deleteInterestId', interestId)} />
        </IconMenu>
    );
};

IconMenuCell.propTypes = {
    interestId: PropTypes.string.isRequired
};

export default IconMenuCell;



/** WEBPACK FOOTER **
 ** ../src/dash/front/interests-page/components/InterestsTable/IconMenuCell.js
 **/